import { connect } from 'react-redux'
import { PhoneSystemNewEditComponent } from './PhoneSystemNewEdit'
import { showPhoneSystemHuntGroupEditFormModal } from 'features/PhoneSystem/PhoneSystemHuntGroupEditFormModal'
import { showPhoneSystemExtensionEditFormModal } from 'features/PhoneSystem/PhoneSystemExtensionEditFormModal'
import { showPhoneSystemNumberEditFormModal } from 'features/PhoneSystem/PhoneSystemNumberEditFormModal'

import showConfirmModal from 'features/Modal/ConfirmModal'
import { push } from 'react-router-redux'
import { showPhoneSystemNumberCreateFormModal } from 'features/PhoneSystem/PhoneSystemNumberCreateFormModal'
import {
  GetPhoneSystemServiceDocument,
  SearchPhoneSystemDidNumbersDocument,
} from 'src/generated/graphql'

const stateToProps = ({ auth }) => ({
  isAdmin: (auth.user.roles && auth.user.roles.includes('ROLE_API_ADMIN')) || auth.adminToken,
})

const confirmationMessage = { message: 'Are you sure?<br />This cannot be undone.' }

export const dispatchToProps = {
  showPhoneSystemHuntGroupEditFormModal,
  showPhoneSystemExtensionEditFormModal,
  showPhoneSystemNumberEditFormModal,
  showPhoneSystemNumberCreateFormModal,

  handleDeletePhoneSystem: deletePhoneSystemMutation => dispatch =>
    dispatch(showConfirmModal(confirmationMessage))
      .then(() => deletePhoneSystemMutation())
      .then(() => dispatch(push('/dashboard/hosted-voice/phone-systems'))),

  handleDeleteItem: (deleteMutation, variables, phoneSystemId) => dispatch =>
    dispatch(showConfirmModal(confirmationMessage)).then(() =>
      deleteMutation({
        variables,
        refetchQueries: [
          { query: GetPhoneSystemServiceDocument, variables: { id: phoneSystemId } },
          { query: SearchPhoneSystemDidNumbersDocument, variables: { query: '' } },
        ],
        awaitRefetchQueries: true,
      })
    ),
}

export default connect(stateToProps, dispatchToProps)(PhoneSystemNewEditComponent)



// WEBPACK FOOTER //
// src/pages/Services/HostedVoice/PhoneSystemsEdit/PhoneSystemNewEdit.container.ts